import {API_BASE} from '../apiConfig';

/**
 * Отметить на сервере, что игрок закрыл новость о рейтинговых обличиях (см.
 * RankSkinsNewsModal): больше она не покажется ни на этом, ни на другом
 * устройстве. В редаксе меню отмечает новость само и сразу
 * (setRankSkinsNewsSeen), поэтому ответ здесь не нужен.
 *
 * Ошибка сети сюда не пробрасывается: модалка уже закрыта, и ронять из-за
 * отметки нечего — в худшем случае новость покажется еще раз в другой сессии.
 *
 * @returns {Promise<boolean>} записал ли сервер отметку
 */
export const markRankSkinsNewsSeen = async () => {
  try {
    const res = await fetch(`${API_BASE}/users/me/rank-skins-news/seen`, {
      method: 'POST',
      credentials: 'include',
    });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    return true;
  } catch (error) {
    console.error('[RankSkinsNews] Не удалось сохранить отметку показа', error);
    return false;
  }
};
